import * as React from 'react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectAllLeads } from '@user/store/lead/slice'
import { NoResultsCard } from '@sales-center/components'
import { LeadCard } from './LeadCard'
import { updateLoadingState } from '@sales-center/common'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  useGetAllFunnelStagesOnMount,
  useGetSalesFunnelListOnMount,
} from '@user/store/salesFunnel'
import { useGetAppointmentsDataOnMount } from '@user/store/scheduling'
import { useGetUserListOnMount } from '@user/store/users'

interface Props {
  loading: boolean
  canConvert: boolean
  canUpdate: boolean
  canDelete: boolean
}

export function LeadCardList(props: Props) {
  const { loading, ...rest } = props
  const dispatch = useAppDispatch()

  const funnelStageStatus = useGetAllFunnelStagesOnMount()
  const funnelListStatus = useGetSalesFunnelListOnMount()
  const userListStatus = useGetUserListOnMount()
  const leads = useSelector(selectAllLeads)

  const { appointmentsMap } = useGetAppointmentsDataOnMount(1, leads)

  const loadingState =
    loading ||
    funnelStageStatus === 'pending' ||
    funnelListStatus === 'pending' ||
    userListStatus === 'pending'

  useEffect(() => {
    dispatch(updateLoadingState(loadingState ? 'visible' : 'hidden'))
  }, [dispatch, loadingState])

  // The page can unmount while a list refetch is in flight (e.g. auto-review navigates to the new
  // lead), which would otherwise leave the global overlay visible on the next page.
  useEffect(
    () => () => {
      dispatch(updateLoadingState('hidden'))
    },
    [dispatch],
  )

  return leads.length === 0 ||
    funnelStageStatus == 'pending' ||
    userListStatus == 'pending' ? (
    <NoResultsCard label="No leads added yet." />
  ) : (
    <>
      {leads.map((l) => (
        <LeadCard
          {...rest}
          key={l.id}
          lead={l}
          hasScheduledAppointment={appointmentsMap.get(l.id) ?? false}
        />
      ))}
    </>
  )
}
